if (!customElements.get('content-tabs')) {
  class ContentTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.tabs = Array.from(this.querySelectorAll('[data-content-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-content-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
        tab.addEventListener('keydown', (event) => this.onKeyDown(event));
      });
      this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event));
    }

    activate(activeTab, focus = false) {
      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive.toString());
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === activeTab.getAttribute('aria-controls');
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      if (focus) activeTab.focus();
    }

    onBlockSelect(event) {
      const panel = event.target.closest('[data-content-panel]');
      if (!panel || !this.contains(panel)) return;

      const tab = this.tabs.find((tab) => tab.getAttribute('aria-controls') === panel.id);
      if (tab) this.activate(tab);
    }

    onKeyDown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex;

      switch (event.key) {
        case 'ArrowLeft':
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'ArrowRight':
          nextIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activate(this.tabs[nextIndex], true);
    }
  }

  customElements.define('content-tabs', ContentTabs);
}
